import React, { useState, useEffect } from 'react';
import { getDashboard } from '../../api/client';

export default function Dashboard() {
  const [data, setData] = useState({ templatesCount: null, toolsCount: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getDashboard()
      .then((res) => {
        if (!cancelled) setData({ templatesCount: res.templatesCount, toolsCount: res.toolsCount });
      })
      .catch((err) => {
        if (!cancelled) setError(err?.body?.message || err?.message || 'Failed to load dashboard');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <div>
      <h1 className="h4 mb-3">Dashboard</h1>
      <p className="text-muted">Welcome to FormFit Admin. Use the sidebar to manage templates, tools, and content.</p>
      {error && (
        <div className="alert alert-danger py-2 small" role="alert">
          {error}
        </div>
      )}
      <div className="row g-4 mt-2">
        <div className="col-md-4">
          <div className="card">
            <div className="card-body py-4">
              <h5 className="card-title">Templates</h5>
              <p className="mb-0 fs-4 fw-700 text-dark">
                {loading ? (
                  <span className="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true" />
                ) : (
                  data.templatesCount ?? '—'
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="card-body py-4">
              <h5 className="card-title">Tools</h5>
              <p className="mb-0 fs-4 fw-700 text-dark">
                {loading ? (
                  <span className="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true" />
                ) : (
                  data.toolsCount ?? '—'
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="card-body py-4">
              <h5 className="card-title">Content</h5>
              <p className="mb-0 fs-4 fw-700 text-dark">—</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
